module.exports = __webpack_public_path__ + "img/search.96322e1c.svg";